import styled from '@emotion/styled';
import First from './first/first';
import Second from './second/second';
import Blog from './third';
import Fourth from './fourth';
import Fifth from './fifth';
import Sixth from './sixth';
import Seventh from './seventh';
import Eigth from './eigth';
import Nineth from './nineth';
import Insta from './insta';
import BrandStory from './barnd/brandStory';
import Page from '../../layout/Page';
import EventModal from "./EventModal";
// import Tenth from './tenth';
// import Hooking from './hooking';
import ReactPixel from 'react-facebook-pixel';
import { forwardRef, useEffect, useRef, useState } from 'react';
import Cta from './cta';
import Price from './price';
import Memory from "./memory";
import { keyframes } from '@emotion/react';

const Elem:React.FC<any> = () =>{
  const [hasScrolled50, setHasScrolled50] = useState(false);
  const [hasScrolled70, setHasScrolled70] = useState(false);
  const [hasScrolled90, setHasScrolled90] = useState(false);
  const [ isButtonFixed, setIsButtonFixed ] = useState(false);
  const [ showModal, setShowModal ] = useState(false);
  const buttonRef = useRef<HTMLDivElement | null>(null);
  const topButtonPosition = 1500;
  const buttonTopPosition = 10000;
  
  const handleGoToLoginButton = () => {
    ReactPixel.fbq('track', 'StartTrial', {
      "currency": "KRW",
      "value" : 0.00,
      "predicted_ltv" : 10000,
      "event_type" : "bottom"
    });
    
    // window.location.href = "/login"
    window.location.href = "/subscribe"
  }

  const closeModal = () => {
    if (showModal) {
      setShowModal(false)
    }
  };
  
  useEffect(() => {
    setShowModal(true)
  }, [])


  useEffect(() => {
    const handleScroll = async () => {
      const scrollPosition = window.scrollY + window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      // scroll50%일때 이벤트 보내기
      if (scrollPosition > documentHeight * 0.5 && !hasScrolled50) {
        ReactPixel.fbq('trackCustom', 'HalfwayPercentScrolled', {
          name: "HalfwayPercentScrolled"
        });
        setHasScrolled50(true);
      };

      if (scrollPosition > documentHeight * 0.7 && !hasScrolled70) {
        ReactPixel.fbq('trackCustom', 'SeventyPercentScrolled', {
          name: "SeventyPercentScrolled"
        });
        setHasScrolled70(true);
      };
      

      if (scrollPosition > documentHeight * 0.9 && !hasScrolled90) {
        ReactPixel.fbq('trackCustom', 'NinetyPercentScrolled', {
          name: "NinetyPercentScrolled"
        });
        setHasScrolled90(true);
      };

      // 버튼 고정 위치 처리
      if (topButtonPosition > scrollPosition) {
        setIsButtonFixed(false);
      } else if (topButtonPosition < scrollPosition && scrollPosition < buttonTopPosition) {
        setIsButtonFixed(true);
      } else {
        setIsButtonFixed(false);
      }
    }

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    }

  },[hasScrolled50, hasScrolled70 , hasScrolled90]);


  return (
    <>
      <Page disable={true}>
        <ContentsConatiner>
          <Body>
            <First />
            <Second />
            <Eigth />
            <Sixth />
            <Memory/>
            <Fifth />
            <Seventh />
            {/* <Second/> */}
            {/* <Hooking/> */}
            {/* <Fourth/> */}            
            {/* <Tenth /> */}
            {/* <Price /> */}
            <ButtonWrapper>
              <ButtonContainer ref={buttonRef} isFixed={isButtonFixed}>
                <SubscribeButton onClick={handleGoToLoginButton}>
                인화구독 더 알아보기
                </SubscribeButton>
              </ButtonContainer>
            </ButtonWrapper>
            <Insta />
            <Blog/>
            <BrandStory/>
            <Cta/>
          </Body>
        </ContentsConatiner>
      </Page>
      {/* {showModal && <EventModal showModal={showModal} closeModal={closeModal} />} */}
    </>
  )
};

export default Elem;


const ContentsConatiner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Body = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

// const ButtonConatiner = styled.div<{ isFixed: boolean }>`
//   width: 70%;
//   height: 55px;
//   /* position: fixed;
//   bottom: 20px;
//   right: 60px;
//   padding: 10px 20px; */
//   color: white;
//   border: none;
//   border-radius: 5px;
//   cursor: pointer;
//   box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

//   border-radius: 30px;
//   background-color: #e1a349;

//   margin: 0 auto;
// `;

interface ButtonContainerProps {
  isFixed: boolean;
};

interface ButtonContainerProps {
  isFixed: boolean;
};

const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #ede3cd;
`;

const slideUp = keyframes`
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

// const ButtonContainer = styled.div<ButtonContainerProps>`
//   width: 70%;
//   height: 55px;
//   color: white;
//   border: none;
//   border-radius: 5px;
//   cursor: pointer;
//   box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
//   border-radius: 30px;
//   /* background-color: #e1a349; */
//   position: ${({ isFixed }) => (isFixed ? 'fixed' : 'relative')};
//   bottom: ${({ isFixed }) => (isFixed ? '20px' : 'auto')};
//   right: ${({ isFixed }) => (isFixed ? '60px' : 'auto')};
//   margin: ${({ isFixed }) => (isFixed ? '0' : '0 auto')};
//   transform: ${({ isFixed }) => (isFixed ? 'translateX(-50%)' : 'none')};
//   left: ${({ isFixed }) => (isFixed ? '50%' : 'auto')}; 
//   margin-bottom: 25px;
//   margin-top: 50px;
//   animation: ${({ isFixed }) => isFixed ? slideUp : 'none'} 0.5s ease-in-out;
//   display: ${({ isFixed }) => isFixed ? 'block' : 'none'};
//   /* transition: all 0.5s ease-in-out; */
// `;

const ButtonContainer = styled.div<ButtonContainerProps>`
  width: 70%;
  height: 55px;
  color: white;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  background-color: #e1a349;
  position: ${({ isFixed }) => (isFixed ? 'fixed' : 'relative')};
  bottom: ${({ isFixed }) => (isFixed ? '20px' : 'auto')};
  margin: ${({ isFixed }) => (isFixed ? '0' : '0 auto')};
  margin-bottom: 25px;
  margin-top: 50px;
  animation: ${({ isFixed }) => (isFixed ? slideUp : 'none')} 0.5s ease-in-out;
  display: ${({ isFixed }) => (isFixed ? 'block' : 'none')};
  transition: all 0.5s ease-in-out;
`;

const SubscribeButton = styled.button`
  width: 100%;
  height: 100%;
  font-weight: bold;
  /* background-color: #e1a349; */
  background-color: black;
  color: white;
  border-radius: 40px;
`;